<div class="info-dialog-container">
  <button class="close-icon-btn" (click)="onClose()" aria-label="Close">
    <mat-icon>close</mat-icon>
  </button>
  <div class="info-dialog-header" [ngClass]="data.type || 'info'">
    <mat-icon *ngIf="data.type === 'success'">check_circle</mat-icon>
    <mat-icon *ngIf="data.type === 'error'">error</mat-icon>
    <mat-icon *ngIf="data.type === 'warning'">warning</mat-icon>
    <mat-icon *ngIf="data.type === 'info' || !data.type">info</mat-icon>
    
    <h2>{{ data.title || 'Thông báo' }}</h2>
  </div>

  <div class="info-dialog-content">
    <p>{{ data.message }}</p>
  </div>

  <div class="info-dialog-actions">
    <button class="action-btn" (click)="onClose()">
      {{ data.confirmText || 'Đóng' }}
    </button>
  </div>
</div>
